'use client';
import { createContext, useContext, useMemo } from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import {
  type CompareOffersStore,
  type CompareOffersStoreState,
  createCompareOffersStore,
} from './store';

const DEFAULT_MAX_SELECTED_OFFERS = 3;

export const CompareOffersStoreContext = createContext<CompareOffersStore | null>(null);

export function CompareOffersStoreProvider({
  children,
  maxSelectedOffers = DEFAULT_MAX_SELECTED_OFFERS,
}: {
  children: React.ReactNode;
  maxSelectedOffers?: number;
}) {
  const store = useMemo(() => createCompareOffersStore(maxSelectedOffers), [maxSelectedOffers]);

  return (
    <CompareOffersStoreContext.Provider value={store}>
      {children}
    </CompareOffersStoreContext.Provider>
  );
}

export function useCompareOffersStore<T>(
  selector: (state: CompareOffersStoreState) => T,
  equalityFn?: (left: T, right: T) => boolean,
): T {
  const store = useContext(CompareOffersStoreContext);
  if (!store) throw new Error('Missing CompareOffersStoreProvider in the tree');

  return useStoreWithEqualityFn(store, selector, equalityFn);
}
